import { useState } from "react";
import { Navigate } from "react-router-dom";
import { betaHandoffQuery } from "@hub";
import { appUrl } from "../../config";
import { getBetaDraft, storeJourneyTester } from "../../beta/store";
import BetaLayout from "./BetaLayout";

const EMPTY = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  role: "agent",
  brokerage: "",
  license: "",
};

export default function BetaProfile() {
  const draft = getBetaDraft();
  const [form, setForm] = useState({
    ...EMPTY,
    firstName: draft.firstName || "",
    lastName: draft.lastName || "",
    email: draft.email || "",
    phone: draft.phone || "",
    role: draft.role === "broker" ? "broker" : "agent",
    brokerage: draft.brokerage || "",
    license: draft.license || "",
  });
  const [error, setError] = useState("");

  if (!draft.acceptedAt) {
    return <Navigate to="/beta/agreement" replace />;
  }

  function setField(key, value) {
    setForm((current) => ({ ...current, [key]: value }));
  }

  function onSubmit(event) {
    event.preventDefault();
    const firstName = form.firstName.trim();
    const lastName = form.lastName.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    if (!firstName || !lastName || !email || !phone) {
      setError("First name, last name, email, and phone are required.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a working email address.");
      return;
    }
    const profile = {
      ...form,
      firstName,
      lastName,
      email,
      phone,
      brokerage: form.brokerage.trim(),
      license: form.license.trim(),
      acceptedAt: draft.acceptedAt,
      betaRole: form.role,
    };
    storeJourneyTester(profile);
    window.location.assign(appUrl(betaHandoffQuery(profile)));
  }

  return (
    <BetaLayout>
      <article className="beta-card">
        <p className="beta-kicker">Step three</p>
        <h1>Create your Beta profile</h1>
        <p className="lead">
          This record is marked as a Beta tester and opens the REChecklist desk under your name.
          License numbers are recorded for the desk — they are not a California DRE certification.
        </p>
        <form className="beta-form" onSubmit={onSubmit}>
          <label className="field">
            <span>First Name</span>
            <input
              value={form.firstName}
              onChange={(event) => setField("firstName", event.target.value)}
              autoComplete="given-name"
              required
            />
          </label>
          <label className="field">
            <span>Last Name</span>
            <input
              value={form.lastName}
              onChange={(event) => setField("lastName", event.target.value)}
              autoComplete="family-name"
              required
            />
          </label>
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              value={form.email}
              onChange={(event) => setField("email", event.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label className="field">
            <span>Phone</span>
            <input
              type="tel"
              value={form.phone}
              onChange={(event) => setField("phone", event.target.value)}
              autoComplete="tel"
              required
            />
          </label>
          <fieldset className="beta-role">
            <legend>Role</legend>
            <label className={form.role === "agent" ? "is-on" : ""}>
              <input
                type="radio"
                name="beta-role"
                value="agent"
                checked={form.role === "agent"}
                onChange={() => setField("role", "agent")}
              />
              Agent
            </label>
            <label className={form.role === "broker" ? "is-on" : ""}>
              <input
                type="radio"
                name="beta-role"
                value="broker"
                checked={form.role === "broker"}
                onChange={() => setField("role", "broker")}
              />
              Broker
            </label>
          </fieldset>
          <label className="field">
            <span>Brokerage Name (optional)</span>
            <input
              value={form.brokerage}
              onChange={(event) => setField("brokerage", event.target.value)}
              autoComplete="organization"
            />
          </label>
          <label className="field">
            <span>License Number (optional)</span>
            <input
              value={form.license}
              onChange={(event) => setField("license", event.target.value)}
            />
          </label>
          {error ? <p className="form-error">{error}</p> : null}
          <div className="beta-actions">
            <button type="submit" className="btn">
              Enter REChecklist
            </button>
          </div>
        </form>
      </article>
    </BetaLayout>
  );
}
